/**
 * @desc 留资
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';
@BindAll()
export class StayDataController<T = any> extends BasesController<T> {
  Model = new BaseModel({ type: 'object' });

  /**
   * 行业
   */
  @computed
  get industryList(): Array<any> {
    return lodash.get(this.Model.value, 'industryList', []);
  }

  /**
   * 公司规模
   */
  @computed
  get scaleList(): Array<any> {
    return lodash.get(this.Model.value, 'scaleList', []);
  }

  /**
   * 职务
   */
  @computed
  get jobList(): Array<any> {
    return lodash.get(this.Model.value, 'jobList', []);
  }

  /**
   * @ 获取 行业list
   */
  async getIndustryList() {
    try {
      // const res = await AjaxBasics.request({ ...EnumAPI.order_scoreCheckActivation });
      const industryList = [
        { value: '政府', label: '政府' },
        { value: '教育', label: '教育' },
        { value: '金融', label: '金融' },
        { value: '能源(自然资源)', label: '能源(自然资源)' },
        { value: '交通', label: '交通' },
        { value: '教专业服务育', label: '专业服务' },
        { value: '电信', label: '电信' },
        { value: '制造', label: '制造' },
        { value: '流通', label: '流通' },
        { value: '媒体', label: '媒体' },
        { value: '医疗卫生', label: '医疗卫生' },
        { value: '建筑', label: '建筑' },
        { value: '个人消费服务', label: '个人消费服务' },
        { value: '其他', label: '其他' },
      ];
      this.Model.merge({ industryList });
    } catch (error) {}
  }

  /**
   * @ 获取 公司规模list
   */
  async getScaleList() {
    try {
      // const res = await AjaxBasics.request({ ...EnumAPI.order_scoreCheckActivation });
      const scaleList = [
        { value: '1-30', label: '1-30' },
        { value: '31-100', label: '31-100' },
        { value: '101-500', label: '101-500' },
        { value: '501-1000', label: '501-1000' },
        { value: '1001-5000', label: '1001-5000' },
        { value: '5001-10000', label: '5001-10000' },
        { value: '100001人以上', label: '100001人以上' },
      ];
      this.Model.merge({ scaleList });
    } catch (error) {}
  }

  /**
   * @ 获取 职务list
   */
  async getJobList() {
    try {
      // const res = await AjaxBasics.request({ ...EnumAPI.order_scoreCheckActivation });
      const jobList = [
        { value: '总裁', label: '总裁' },
        { value: '副总裁', label: '副总裁' },
        { value: '总经理', label: '总经理' },
        { value: '操盘手', label: '操盘手' },
        { value: '财务', label: '财务' },
        { value: '审计', label: '审计' },
        { value: '法务', label: '法务' },
        { value: '人力', label: '人力' },
        { value: '技术', label: '技术' },
        { value: '市场营销/销售', label: '市场营销/销售' },
        { value: '商务', label: '商务' },
        { value: '运营', label: '运营' },
        { value: '后勤', label: '后勤' },
        { value: '产品', label: '产品' },
        { value: '其他', label: '其他' },
      ];
      this.Model.merge({ jobList });
    } catch (error) {}
  }

  /**
   * @ 提交
   */
  async submitData(body) {
    try {
      return await AjaxBasics.request({
        ...EnumAPI.content_staydata_save,
        body,
      });
    } catch (error) {}
  }
}
